// /**
//  * Order detail -CSV
//  */

// React
import React from 'react';
import { CSVLink } from 'react-csv';
import { Order } from '../orders/interfaces';
import { Button } from '@material-ui/core';
import RonadIcons from '../../components/iconComponent';

type Props = {
  data: Order[];
  loading: boolean;
};

function CSV(props: Props) {
  const flattData = (data: any) => {
    return data.map((item: any) => {
      return {
        orderItemId: item.id,
        productName: item.productName,
        productCode: item.productCode,
        variantCode: item.variantCode,
        variantId: item.variantId,
        amount: item.amount,
      };
    });
  };

  return (
    <CSVLink
      data={flattData(props.data)}
      filename="Orders.csv"
      style={{
        textDecoration: 'none',
      }}
    >
      <Button
        style={{ marginLeft: '8px' }}
        variant="outlined"
        color="primary"
        size="medium"
        startIcon={<RonadIcons name='download' size={.7} className='text-primary' style={{marginTop: "-4px"}}/>}
      >
        Excel
      </Button>
    </CSVLink>
  );
}

export default CSV;
